module.exports = __webpack_public_path__ + "media/images/team/AnaDiasFonseca-628e3c9f237a9e5eccb5a13b0195b790.png";